/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { CvxMining, CvxMiningInterface } from "../CvxMining";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "ConvertCrvToCvx",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cvx",
    outputs: [
      {
        internalType: "contract ICvx",
        name: "",
        type: "ICvx",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x61032f610026600b82828239805160001a60731461001957fe5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600436106100405760003560e01c80638487474514610045578063923c1d6114610074575b600080fd5b6100626004803603602081101561005b57600080fd5b5035610098565b60408051918252519081900360200190f35b61007c6102e1565b604080516001600160a01b039092168252519081900360200190f35b600080734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b6001600160a01b03166318160ddd6040518163ffffffff1660e01b815260040160206040518083038186803b1580156100e857600080fd5b505afa1580156100fc573d6000803e3d6000fd5b505050506040513d602081101561011257600080fd5b50516040805163553a731160e11b81529051919250600091734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b9163aa74e622916004808301926020929190829003018186803b15801561016557600080fd5b505afa158015610179573d6000803e3d6000fd5b505050506040513d602081101561018f57600080fd5b505160408051631f96e76f60e01b81529051919250600091734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b91631f96e76f916004808301926020929190829003018186803b1580156101e257600080fd5b505afa1580156101f6573d6000803e3d6000fd5b505050506040513d602081101561020c57600080fd5b50516040805163d5abeb0160e01b81529051919250600091734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b9163d5abeb01916004808301926020929190829003018186803b15801561025f57600080fd5b505afa158015610273573d6000803e3d6000fd5b505050506040513d602081101561028957600080fd5b50519050600083858161029857fe5b049050828110156102d25780830383888202816102b157fe5b049750858303808911156102c3578098505b889750505050505050506102dc565b6000955050505050505b919050565b734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b8156fea2646970667358221220da49ced10c9fea7de7d858a599234134faec55d8ca361f1e43099b2ddc0b642364736f6c634300060c0033";

type CvxMiningConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CvxMiningConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CvxMining__factory extends ContractFactory {
  constructor(...args: CvxMiningConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CvxMining";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CvxMining> {
    return super.deploy(overrides || {}) as Promise<CvxMining>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): CvxMining {
    return super.attach(address) as CvxMining;
  }
  connect(signer: Signer): CvxMining__factory {
    return super.connect(signer) as CvxMining__factory;
  }
  static readonly contractName: "CvxMining";
  public readonly contractName: "CvxMining";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CvxMiningInterface {
    return new utils.Interface(_abi) as CvxMiningInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CvxMining {
    return new Contract(address, _abi, signerOrProvider) as CvxMining;
  }
}
